import BookCallCTA from './BookCallCTA';

export default function PricingModelSection() {
  return (
    <section className="py-8 sm:py-12 bg-[#fdfcf9]" aria-labelledby="plans-title">
      <div className="max-w-5xl mx-auto px-6 flex flex-col md:flex-row md:items-center justify-between gap-6 md:gap-12">
        <div className="max-w-2xl">
          <h2 id="plans-title" className="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900">Built on your accounts. One setup fee. Ongoing support.</h2>
          <p className="text-sm sm:text-base text-gray-600 leading-relaxed mt-3">We build and train your AI caller around your workflow. You own the system; your retainer covers support, maintenance, and refinement.</p>
        </div>
        <div className="flex-shrink-0"><BookCallCTA /></div>
      </div>
    </section>
  );
}
